import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 自动装箱记录
export function loadAutoContainerLog(data) {
  return request({
    url: URL.seaExport.loadAutoContainerLog,
    method: 'post',
    data: data
  })
}
